import { render, staticRenderFns } from "./info.vue?vue&type=template&id=351f70a0"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('351f70a0')) {
      api.createRecord('351f70a0', component.options)
    } else {
      api.reload('351f70a0', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=351f70a0", function () {
      api.rerender('351f70a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/info.vue"
export default component.exports